// Brand loader — the Arbox loader.gif served from public/. No CSS spinners.
// See guidelines 05-arbox-ui-design-system.md §12.

interface LoaderProps {
  size?: number;
  fullScreen?: boolean;
  alt?: string;
}

export function Loader({ size = 64, fullScreen = false, alt = 'טוען…' }: LoaderProps) {
  if (fullScreen) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-grey-bg">
        <img src="/loader.gif" alt={alt} width={size} height={size} />
      </div>
    );
  }
  return <img src="/loader.gif" alt={alt} width={size} height={size} />;
}

/**
 * Indicator for antd Spin / ProTable's loading prop:
 *   loading={isFetching ? { spinning: true, indicator: loaderIndicator() } : false}
 */
export function loaderIndicator(size: 'sm' | 'md' | 'lg' = 'md') {
  const px = size === 'sm' ? 24 : size === 'lg' ? 64 : 36;
  return <img src="/loader.gif" alt="" width={px} height={px} />;
}
